export function checkIfFilesAreTooBig(files?: Array<File>): boolean {
    let valid = true;
    if (files) {
        let totalFileSize = 0;
        files.forEach((file) => {
            totalFileSize += file.size;
        });

        const totalFileSizeInMb = totalFileSize / 1024 / 1024;
        if (totalFileSizeInMb > 10) {
            valid = false;
        }
    }
    return valid;
}

export function checkIfFilesAreCorrectType(files?: Array<File>): boolean {
    let valid = true;
    if (files) {
        files.map((file) => {
            if (!["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
                valid = false;
            }
        });
    }
    return valid;
}
